import { Select } from '@mantine/core';
import { UseFormReturnType as Form } from '@mantine/form';
import { IAutomationSetDeviceEvidenceField } from 'pages/revisions-module/template-editor/editors/pipeline/types';
import { useMemo } from 'react';
import { useFormInputs } from 'pages/revisions-module/template-editor/editors/form/input/FormInputsDataProvider';
import { EvidenceFieldSelect } from 'components/selects/EvidenceFieldSelect';

/**
 * Sub-form for set device evidence field automation.
 */
export default function SetDeviceEvidenceFieldSubForm({ form }: { form: Form<IAutomationSetDeviceEvidenceField> }) {
  const { allInputs } = useFormInputs();

  const inputData = useMemo(
    () =>
      allInputs
        .filter(
          ({ context, spec: { type } }) =>
            context === 'device' && type !== 'deviceProperty' && type !== 'deviceEvidenceField'
        )
        .map((input) => ({ value: input.spec.name, label: input.spec.label })),
    [allInputs]
  );

  return (
    <>
      <Select
        data={inputData}
        label="Použiť hodnotu z poľa"
        required
        searchable
        size="sm"
        {...form.getInputProps('inputName')}
      />
      <EvidenceFieldSelect
        applicability="devices"
        size="sm"
        label="Nastaviť do evidenčného poľa"
        searchable
        required
        {...form.getInputProps('evidenceFieldId')}
      />
    </>
  );
}
